import axios from "axios";

class SetupProperitiesService {
    async list() {
        return await axios.get('/api/v1/setup-properities')
            .then(response => response.data);
    }
}

const setupProperitiesService = new SetupProperitiesService();
export default setupProperitiesService;